import React, { useEffect } from 'react'
import { SnackBarProps } from '../../components/Device-table/Provisioning'
import { Box, Typography } from '@mui/material'
import NotificationTable from './NotificationTable/NotificationTable'
import { useLocation } from 'react-router-dom'

interface NotificationPagePops {
  setSnackBarInfo?: React.Dispatch<React.SetStateAction<SnackBarProps>>
}

const NotificationPage = ({ setSnackBarInfo }: NotificationPagePops) => {
  const location = useLocation()
  const { message } = location.state?.data || {}
  useEffect(() => {
    console.log('message::', message)
  }, [message])

  return (
    <>
      <Box className='custom_main_wrapper'>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '20px' }}>
          <Typography sx={{ fontSize: '20px' }}>{'Gateways Go Offline'}</Typography>
        </Box>
      </Box>
      <Box className='d-flex pe-4 ps-4 py-4 w-full '>
        <NotificationTable setSnackBarInfo={setSnackBarInfo} />
      </Box>
    </>
  )
}

export default NotificationPage
